/** Tab placeholders like "Konu 3" / "Topic 2" — not real industry topic names. */
export function isGenericWelcomeTopicTabLabel(label) {
  const s = String(label ?? "").trim();
  if (!s) return true;
  return (
    /^konu\s*#?\s*\d+$/i.test(s) ||
    /^topic\s*#?\s*\d+$/i.test(s) ||
    /^general$/i.test(s) ||
    /^genel$/i.test(s) ||
    /^#\d+$/.test(s)
  );
}

/**
 * Drawer header for metric-20 associated reviews: prefer wizard/API topic name,
 * not GenAI row `label` (often "Konu N").
 */
export function resolveWelcomeReviewsDrawerTopicTitle(
  sourceItem,
  row,
  topicTabLabel,
) {
  const candidates = [
    topicTabLabel,
    sourceItem?.topic,
    row?.topic,
    sourceItem?.topic_name,
    sourceItem?.tag,
    sourceItem?.category,
  ];
  for (const c of candidates) {
    const s = String(c ?? "").trim();
    if (s && !isGenericWelcomeTopicTabLabel(s)) {
      return s;
    }
  }
  const fallback = [sourceItem?.label, row?.label, topicTabLabel];
  for (const c of fallback) {
    const s = String(c ?? "").trim();
    if (s) return s;
  }
  return "";
}
